import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import PrivateRoute from './PrivateRoute'; 

// Import your components
import ResourceManagement from './components/ROS/Admin/ResourceManagement';
import UserManagement from './components/ROS/Admin/UserManagement';
import SystemConfigurat from './components/ROS/Admin/SystemConfiguration';
import Login from './components/Auth/Login';
import DashboardBody from './components/ROS/Dashboard/Overview';
import Alarms from './components/ROS/Dashboard/Alarms';
import AlarNewCaseSubmission from './components/ROS/Dashboard/NewCaseSubmission';
import SubmittedCaseDetails from './components/ROS/Dashboard/SubmittedCase';
import CompletedCaseDetails from './components/ROS/Dashboard/CompletedCase';
import ReportsAnalytics from './components/ROS/Innerpage/Reports&Analytics';
import Profile from './components/ROS/Innerpage/Profile';
import HelpAndSupport from './components/ROS/Innerpage/Help&Support';
import Contact from './components/ROS/Innerpage/Contact';
import News from './components/ROS/Innerpage/News';
import SystemConfigration from './components/ROS/Innerpage/SystemConfigration';
import ResourcesEMS from './components/EMS/EMS/EMSResourceManagement';
import EMSDashboard from './components/EMS/EMS/EMSDashboard';
import EMSReportsAnalytics from './components/EMS/EMS/Reports&Analytics';
import EmsUserManagement from './components/EMS/EMS/UserManagement';
import CasesTab from './components/EMS/EMS/EMSCasesTab/EMSCases';
import CaseDetailTab from './components/EMS/EMS/EMSCasesTab/CaseDetail';
import TransferCaseTab from './components/EMS/EMS/TransferCasesTab/TransferCase';
import TransferDetailsTab from './components/EMS/EMS/TransferCasesTab/TransferDetail';
import EMSRequestsTab from './components/EMS/EMS/RequestsTab/EMSRequests';
import RequestsDetailTab from './components/EMS/EMS/RequestsTab/RequestsDetails';
import HospitalNewCases from './components/EMS/EMS/HospitalCasesTab/HospitalNewCases';
import HostipalDetailtab from './components/EMS/EMS/HospitalCasesTab/HospitalDetailTab';
import EMSClosedCases from './components/EMS/EMS/EMSClosedCasesTab/EMSClosedCases';
import EMSClosedCaseDetailTab from './components/EMS/EMS/EMSClosedCasesTab/EMSClosedCaseDetails';
import EMSSystemConfiguration from './components/EMS/EMS/EMSSystemConfigration/EMSSystemConfigration';
import EMSAlarms from './components/EMS/EMS/Alarms';
import EMSContactUS from './components/EMS/EMS/GenralTabs/Contact';
import EMSProfile from './components/EMS/EMS/GenralTabs/Profile';
import RejectionTab from './components/EMS/EMS/RejectedCase/RejectionTab';
import RejectsCaseDetailsTab from './components/EMS/EMS/RejectedCase/RejecteDetails';
import Transfercasesforfinalapproval from './components/EMS/EMS/Transfercasesforfinalapproval/Transfercasesforfinalapproval';
import TransferCaseFinalApprovalDetails from './components/EMS/EMS/Transfercasesforfinalapproval/TransferCaseFinalApprovalDetails';


function App() {
  return (
    <Router>
        <Routes>
          {/* Public Route */}
          <Route path="/" element={<Login />} />

          {/* Protected Routes */}
          <Route path="/ros/resourcemanagement" element={<PrivateRoute><ResourceManagement /></PrivateRoute>} />
          <Route path="/ros/usermanagement" element={<PrivateRoute><UserManagement /></PrivateRoute>} />
          <Route path="/ros/system" element={<PrivateRoute><SystemConfigurat /></PrivateRoute>} />
          <Route path="/ros/dashboard" element={<PrivateRoute><DashboardBody /></PrivateRoute>} />
          <Route path="/ros/alarms" element={<PrivateRoute><Alarms /></PrivateRoute>} />
          <Route path="/ros/casesubmission" element={<PrivateRoute><AlarNewCaseSubmission /></PrivateRoute>} />
          <Route path="/ros/submittedCase" element={<PrivateRoute><SubmittedCaseDetails /></PrivateRoute>} />
          <Route path="/ros/completedcase" element={<PrivateRoute><CompletedCaseDetails /></PrivateRoute>} />
          <Route path="/ros/reports-analyst" element={<PrivateRoute><ReportsAnalytics /></PrivateRoute>} />
          <Route path="/profile" element={<PrivateRoute><Profile /></PrivateRoute>} />
          <Route path="/help" element={<PrivateRoute><HelpAndSupport /></PrivateRoute>} />
          <Route path="/contact" element={<PrivateRoute><Contact /></PrivateRoute>} />
          <Route path="/news" element={<PrivateRoute><News /></PrivateRoute>} />
          <Route path="/ros/system-configuration" element={<PrivateRoute><SystemConfigration /></PrivateRoute>} />
          <Route path="/ems/resources" element={<PrivateRoute><ResourcesEMS /></PrivateRoute>} />
          <Route path="/ems/dashboard" element={<PrivateRoute><EMSDashboard /></PrivateRoute>} />
          <Route path="/ems/user-management" element={<PrivateRoute><EmsUserManagement /></PrivateRoute>} />
          <Route path="/ems/cases" element={<PrivateRoute><CasesTab /></PrivateRoute>} />
          <Route path="/ems/case-detail" element={<PrivateRoute><CaseDetailTab /></PrivateRoute>} />
          <Route path="/ems/transfer-cases" element={<PrivateRoute><TransferCaseTab /></PrivateRoute>} />
          <Route path="/ems/transfer-detail" element={<PrivateRoute><TransferDetailsTab /></PrivateRoute>} />
          <Route path="/ems/requests" element={<PrivateRoute><EMSRequestsTab /></PrivateRoute>} />
          <Route path="/ems/requests-detail" element={<PrivateRoute><RequestsDetailTab /></PrivateRoute>} />
          <Route path="/ems/hospital-new-cases" element={<PrivateRoute><HospitalNewCases /></PrivateRoute>} />
          <Route path="/ems/hospital-detail" element={<PrivateRoute><HostipalDetailtab /></PrivateRoute>} />
          <Route path="/ems/closed-cases" element={<PrivateRoute><EMSClosedCases /></PrivateRoute>} />
          <Route path="/ems/closed-case-detail" element={<PrivateRoute><EMSClosedCaseDetailTab /></PrivateRoute>} />
          <Route path="/ems/reports-analyst" element={<PrivateRoute><EMSReportsAnalytics /></PrivateRoute>} />
          <Route path="/ems/system-configuration" element={<PrivateRoute><EMSSystemConfiguration /></PrivateRoute>} />
          <Route path="/ems/alarms" element={<PrivateRoute><EMSAlarms /></PrivateRoute>} />
          <Route path="/ems/contact" element={<PrivateRoute><EMSContactUS /></PrivateRoute>} />
          <Route path="/ems/profile" element={<PrivateRoute><EMSProfile /></PrivateRoute>} />
          <Route path="/ems/rejected-case" element={<PrivateRoute><RejectionTab /></PrivateRoute>} />
          <Route path="/ems/rejects-case-details" element={<PrivateRoute><RejectsCaseDetailsTab /></PrivateRoute>} />
          <Route path="/ems/transfer-cases-final-approval" element={<PrivateRoute><Transfercasesforfinalapproval /></PrivateRoute>} />
          <Route path="/ems/transfer-case-final-approval-details" element={<PrivateRoute><TransferCaseFinalApprovalDetails /></PrivateRoute>} />
        </Routes>
    </Router>
  );
}

export default App;
